/** @returns {boolean} */
export function isAndroid() {
    const ua     = navigator.userAgent || '';
    const uaData = navigator.userAgentData;

    return /Android/i.test(ua) ||
        (uaData && uaData.platform === 'Android') ||
        (navigator.maxTouchPoints > 0 && /Linux/.test(navigator.platform) && !/CrOS/.test(ua));
}

/**
 * @param {Object}      address             - Address object with address, postcode, city properties
 * @param {Object|null} geocode             - Geocode object with result.position.lat/lon (optional)
 * @param {boolean}     useAndroidGeoLink   - Whether to use Android geo: link
 */
export function openNavigation(address, geocode, useAndroidGeoLink) {
    if (useAndroidGeoLink && geocode && geocode.result && geocode.result.position) {
        const geoLink           = `geo:${geocode.result.position.lat},${geocode.result.position.lon}`;
        const destinationString = buildAddressString(address, ', ');

        window.open(geoLink + `?q=${encodeURIComponent(destinationString)}`);
    } else {
        let url            = 'https://www.google.com/maps/dir/?api=1';
        let destinationUrl = buildAddressString(address, '+').replace(/\s/g, '+');

        if (destinationUrl) {
            destinationUrl = '&destination=' + destinationUrl;
        }
        window.open(url + destinationUrl + '&travelmode=driving');
    }
}

/**
 * @param {Object} address   - Address object with address, postcode, city properties
 * @param {string} separator - Separator between address parts
 * @returns {string}
 */
function buildAddressString(address, separator) {
    return [address.address, address.postcode, address.city]
        .map(part => (part || '').trim())
        .filter(part => part !== '')
        .join(separator)
    ;
}
